<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 42"
      size="small"
      resizable
      border
      row-id="materialCategoryCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :tree-config="{ children: 'children', reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.materialCategoryStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.materialCategoryStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.materialCategoryCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.materialCategoryCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.materialCategoryStatus === 'Y'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.materialCategoryCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('table_label_material_category_no') || '分类编号',
          field: 'materialCategoryNo',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
        },
        {
          title: this.$l('table_label_material_category_name') || '分类名称',
          field: 'materialCategoryName',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
        },
        {
          title:
            this.$l('table_label_material_category_name_En') || '分类名称英文',
          field: 'materialCategoryNameEn',
          minWidth: 250,
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
        },
        {
          title: this.$l('table_label_classLevel') || '层级',
          field: 'classLevel',
          width: 60,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
        },
        {
          title: this.$l('table_label_isLast') || '末级',
          field: 'isLast',
          width: 60,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
        },
        {
          field: 'materialCategoryStatus',
          align: 'center',
          width: 80,
          title: this.$l('INDEX.Status') || '有效状态',
          slots: { default: 'status' },
          showHeaderOverflow: 'title',
        },
        {
          field: 'createBy',
          align: 'center',
          minWidth: 120,
          title: this.$l('INDEX.table_label_created_by') || '创建人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'createDate',
          align: 'center',
          minWidth: 170,
          title: this.$l('INDEX.table_label_created_date') || '创建时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyBy',
          align: 'center',
          minWidth: 120,
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyDate',
          align: 'center',
          minWidth: 170,
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    del(materialCategoryCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .materialCategoryDelApi({ materialCategoryCode })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
            this.onCurrentTreeChange()
          })
      })
    },
    // onCurrentChange({ row }) {
    //   this.$emit('selectMaterialList', row)
    // },

    onCurrentTreeChange() {
      this.$eventBus.$emit('selectTreeList')
    },
  },
}
</script>
